<template>
  <span style="margin-left:5px;"><img style="margin:5px 0px;width:190px" :src="logoUrl"></span>
</template>
<script>
import { mapGetters } from 'vuex'
import logoUrl from '@/assets/login_images/logo2.png'
export default {
  computed: {
    ...mapGetters([
      'sidebar'
    ])
  },
  data() {
    return {
      logoUrl: logoUrl
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Logo/index.vue